// src/pages/QuotationRecord/QuotationRecordSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { deleteQuotationRecord, fetchQuotationRecord, fetchQuotationWithDetails } from "./QuotationRecordThunk";

const initialState = {
  list: [],
  details: [], // when "with item"
  groupWise: [],
  categoryWise: [],
  selectedQuotationRecord: null,
  isEditQuotationRecord: false,
  loading: false,
  error: null,
  accessType: "WRITE",
  filters: {
    filterType: "All",
    recordType: "without item",
    customerId: null,
    itemId: null,
    groupId: null,
    categoryId: null,
    locationId: null,
    userId: null,
    tag_groupnameid: null,
    tagFeildNameid: null,
    tagGroupFields: null,
    fromDate: null,
    toDate: null,
  },
};


const quotationRecordSlice = createSlice({
  name: "quotationRecord",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetData: (state) => {
      state.list = [];
      state.details = [];
      state.groupWise = [];
      state.categoryWise = [];
    },
    setSelectedQuotationRecord: (state, action) => {
      state.selectedQuotationRecord = action.payload;
    },
    setIsEditQuotationRecord: (state, action) => {
      state.isEditQuotationRecord = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuotationRecord.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchQuotationRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;   // ✅ mapped rows
      })
      .addCase(fetchQuotationRecord.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteQuotationRecord.fulfilled, (state, action) => {
      state.list = state.list.filter((q) => q.id !== action.payload.id);
    })
    .addCase(fetchQuotationWithDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchQuotationWithDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedQuotationRecord = action.payload;
        state.isEditQuotationRecord = true;
      })
      .addCase(fetchQuotationWithDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});


export const { setFilters, resetData, setSelectedQuotationRecord,
  setIsEditQuotationRecord, } = quotationRecordSlice.actions;
export default quotationRecordSlice.reducer;
